import { firestoreAction } from 'vuexfire'
import db from '../firebase'

const state = {
  mapps: [],
  mappingsFetched: false,
}
const getters = {
  Mappings: (state) => {
    return state.mapps
  },
 
  mappingsFetched: (state) => {
    return state.mappingsFetched
  },
}
const mutations={
  logout_Mappings(state){
    state.mapps=[];
    state.mappingsFetched=false;
      },

      archive_(state, Map){
    let Index= state.mapps.find(map => map.id ==Map.id);
        let Maps= state.mapps;
        Maps[Index] = Map
        state.mapps= Maps; 
          }
}
const actions = {

  logoutMappings ({commit}) {
    commit('logout_Mappings')
},

initMappings: firestoreAction(({ bindFirestoreRef,state  }, SchoolId) => {
  bindFirestoreRef('mapps', db.collection('mappings').where('schoolId', '==', SchoolId)).then((res) => {
    state.mappingsFetched=true;
  })
}),

initMappingsforMe({state },data){
  let Mappings=[];//SkolID och lärarId
  
  db.collection('mappings').where('schoolId', '==', data.schoolId).where("class",'in', data.id).get().then(function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
              const id = doc.id
              const output = doc.data()
              output.id=id;
              Mappings.push(output)
            })
     state.mapps= Mappings
      state.mappingsFetched=true;
    })
   
         
  },
             
  
  removeMapping({},MapId){
    db.collection('mappings').doc(MapId).delete()
  },

archive({commit},Map){
  Map.archive=true;
  commit("archive_", Map);
  db.collection('mappings').doc(Map.id).update({archive: true})
},

  updateAnswer({state},answers){

    let Map= state.mapps.find(map => map.id ==answers.id);
    if (Map!=null) {
      
    let newAnswer=Map.answerId.findIndex(element=> element== answers.teacherId )
//  (newAnswer)
    if (-1==newAnswer) {
       Map.answerId.push(answers.teacherId)
    Map.answer.push({step:answers.step,answers: answers.answers, updated:  Date.now() })
    }
    else
    {
      Map.answer[newAnswer]={step:answers.step,answers: answers.answers , updated:  Date.now() }
    }

   //Adds map to the array so it changes category (påbörjad...) och step.
   let MapIndex= state.mapps.findIndex(map => map.id ==answers.id);
   state.mapps.splice(MapIndex, 1, Map);
    db.collection('mappings').doc(Map.id).update({answer: Map.answer, answerId: Map.answerId})
    
  }

  },
  createMapping({},map){
    
    map.answerId= []
    map.answer= []
    map.uploadDate=  Date.now() 
    db.collection('mappings').add(map);
    // state.mapps.push(map)
      },

 
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
